import { render } from "./TestimonialsSliderItem.vue?vue&type=template&id=57aedec8"
import script from "./TestimonialsSliderItem.vue?vue&type=script&lang=js"
export * from "./TestimonialsSliderItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__